import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ListTodo, AlertCircle, Calendar, Sparkles, ArrowRight } from "lucide-react";
import api from "@/lib/api";
import { useWorkspace } from "@/contexts/WorkspaceContext";
import { formatDueDate } from "@/lib/taskHelpers";

export default function DashboardTaskWidget() {
  const { currentWorkspace } = useWorkspace();
  const [data, setData] = useState(null);
  useEffect(() => {
    if (!currentWorkspace) return;
    api
      .get(`/tasks/dashboard-summary`, { params: { workspace_id: currentWorkspace.workspace_id } })
      .then((r) => setData(r.data))
      .catch(() => setData(null));
  }, [currentWorkspace]);

  return (
    <div className="bloq-card p-6" data-testid="dashboard-task-widget">
      <div className="flex items-center justify-between mb-4">
        <p className="bloq-headline text-xl">My tasks</p>
        <Link to="/app/tasks" className="text-xs text-[#005e7a] font-medium hover:underline">Open all</Link>
      </div>
      <div className="grid grid-cols-3 gap-2 mb-4">
        <Stat label="Open" value={data?.my_open ?? 0} testid="widget-open" />
        <Stat label="Overdue" value={data?.overdue ?? 0} accent="#dc2626" testid="widget-overdue" />
        <Stat label="Due today" value={data?.due_today ?? 0} accent="#0284c7" testid="widget-today" />
      </div>
      {data?.recent?.length ? (
        <ul className="flex flex-col gap-1.5">
          {data.recent.slice(0, 4).map((t) => (
            <li key={t.task_id} className="flex items-center justify-between text-sm py-1.5">
              <Link to={`/app/tasks`} className="truncate flex-1 hover:underline">{t.title}</Link>
              <span className="text-[11px] text-[#82828c]">{t.due_date ? formatDueDate(t.due_date) : "—"}</span>
            </li>
          ))}
        </ul>
      ) : (
        <p className="text-sm text-[#82828c]">Nothing assigned. Suspiciously peaceful.</p>
      )}
    </div>
  );
}

function Stat({ label, value, accent = "#005e7a", testid }) {
  return (
    <div className="text-center" data-testid={testid}>
      <p className="text-[10px] uppercase tracking-widest text-[#82828c] font-medium">{label}</p>
      <p className="bloq-display text-2xl mt-1" style={{ color: accent }}>{value}</p>
    </div>
  );
}
